import React from "react";
import { Table, Badge } from "react-bootstrap";
import "./DashboardComponents.css";

// Phase 5, §1/§10. "Where a composite score is configured, display: metric
// name, raw value, normalized value, weight, contribution, final total,
// exclusion reason." This component renders the backend-calculated
// performance_scorecard_metric_results verbatim — it never recomputes or
// re-derives a score client-side.
const STATUS_VARIANTS = { INCLUDED: "success", INFORMATIONAL: "secondary", NOT_APPLICABLE: "light", INSUFFICIENT_DATA: "warning", EXCLUDED: "dark", ERROR: "danger" };

function fmt(v) {
  if (v === null || v === undefined) return "Not Available";
  return typeof v === "number" ? (Math.round(v * 100) / 100).toString() : String(v);
}

export default function PerformanceScoreBreakdown({ scorecard }) {
  if (!scorecard) return <div className="text-muted small">No scorecard calculated for this period.</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <strong>Total Score:</strong> {scorecard.total_score != null ? scorecard.total_score : "Not Available"}
          {scorecard.grade && <span className="ms-2"><Badge bg="info">{scorecard.grade}</Badge></span>}
        </div>
        <Badge bg={scorecard.status === "FINALIZED" ? "success" : scorecard.status === "INVALIDATED" ? "danger" : "secondary"}>{scorecard.status}</Badge>
      </div>
      <div className="text-muted small mb-2">
        {scorecard.applicable_metric_count} of {scorecard.raw_metric_count} metrics applicable; {scorecard.unavailable_metric_count} unavailable/insufficient data.
      </div>
      <div className="table-responsive perf-score-table-wrap">
        <Table size="sm" bordered className="mb-0 perf-score-table">
          <thead>
            <tr>
              <th>Metric</th><th>Raw Value</th><th>Target</th><th>Normalized</th><th>Weight %</th><th>Contribution</th><th>Status</th><th>Exclusion Reason</th>
            </tr>
          </thead>
          <tbody>
            {(scorecard.metric_results || []).map((r) => (
              <tr key={r.id}>
                <td>{r.metric_name} <span className="text-muted small">({r.code})</span></td>
                <td>{fmt(r.raw_value)}{r.unit ? ` ${r.unit}` : ""}</td>
                <td>{fmt(r.target_value)}</td>
                <td>{fmt(r.normalized_value)}</td>
                <td>{fmt(r.weightage)}</td>
                <td>{fmt(r.weighted_contribution)}</td>
                <td><Badge bg={STATUS_VARIANTS[r.status] || "secondary"}>{r.status}</Badge></td>
                <td className="text-muted small">{r.exclusion_reason || "—"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
